import { render, staticRenderFns } from "./filter-favourite-category-button-selector.vue?vue&type=template&id=4ea96596&"
import script from "./filter-favourite-category-button-selector.vue.ts?vue&type=script&lang=ts&"
export * from "./filter-favourite-category-button-selector.vue.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports